export const VALIDATION_REQUEST_INDEX_KEY = 'ValidationRequest';

export const shouldRefreshApprovalBadgeFromRows = (
    rows: Array<{ indexKey?: string }>
): boolean => rows.some(item => item.indexKey === VALIDATION_REQUEST_INDEX_KEY);
